import { useEffect, useState } from "react";
import { NotesTableV3 } from "@/entities/notes-table-v3";
import { useContainerSize } from "@/shared/hooks";
import { DEFAULT_NOTE_TYPES_LABELS } from "@/services/api";
import type { FC } from "react";
import type { WidgetContentProps } from "../../types";
import { useDashboardsCommitmentsTable } from "../../lib";
import { NoNotesWidget } from "../NoNotesWidget";
import styles from "./styles.module.scss";

type Props = {
  widgetId?: string;
  directionFilter?: WidgetContentProps["directionFilter"];
};

export const DashboardsCommitmentsTable: FC<Props> = ({ widgetId, directionFilter }) => {
  const { state, methods } = useDashboardsCommitmentsTable({
    widgetId,
    headerDirectionFilter: directionFilter,
  });
  const { columns, dataSource, isLoading } = state;
  const { onRowClick } = methods;
  const { containerRef, containerHeight } = useContainerSize({});
  const [key, setKey] = useState(0);

  useEffect(() => {
    setKey((prev) => prev + 1);
  }, [containerHeight]);

  if (!dataSource.length) {
    return <NoNotesWidget widgetNoteType={DEFAULT_NOTE_TYPES_LABELS.DEFAULT_COMMITMENT} />;
  }

  return (
    <div ref={containerRef} className={styles.container}>
      <NotesTableV3
        key={key}
        virtual
        onRow={(record) => ({ onClick: () => onRowClick(record) })}
        scroll={{ y: containerHeight - 105, x: "max-content" }}
        rowKey={(row) => row.id}
        columns={columns}
        dataSource={dataSource}
        loading={isLoading}
        isPaginationVisible={false}
      />
    </div>
  );
};
